<template>
  <fragment>
    <HomeBanner />
    <HomeNews />
    <div class="option-types-block">
    
    </div>

    <div class="cta-block-wrapper">
      <div class="container">
        <div class="cta-block cta-block-2 clearfix cta-block__spill">
            <div class="cta-block--container-width-sizer">
              <div class="cta-block--container">
                <div class="cta-block--container-row">
                  <div class="cta-block--container-cell cta-block--text-cell " v-html="$t('general.cta-title')">
                   <!-- <span class="word">{{$t('general.cta-title')}}</span> -->
                  </div>
                  <div class="cta-block--container-cell cta-block--cta-cell">

                    <a href="/register"
                      class="btn-fluid btn-lg-pad btn-negative btn btn-extruded"> {{$t('general.cta-button')}}</a>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>

    <div class="p-modal p-modal__option-types-block" id="option-highlow-modal" data-toggle-group="option-types">
      <div class="p-modal--mobile-title option-types-block--item--heading">
        {{$t('option-types.normal.title')}}
        <div class="p-modal--mobile-close toggler" data-toggle-target="#option-highlow-modal" data-toggle-class="open">
        </div>
      </div>
      <div class="p-modal--body-wrapper">
        <span class="p-modal--mobile-body-wrapper">
          <div class="p-modal--body">
            <div class="p-modal--content-wrapper">
              <div class="p-modal--content centered">
                <div class="container">
                  <div class="p-modal--content--inner option-types-block--item">
                    <div class="p-modal--bg toggler" data-toggle-target="#option-highlow-modal"
                      data-toggle-class="open">
                    </div>
                    <img data-src="@/assets/images/option-types-bg-1.jpg" class="i-option-type-block--item--background"
                      src="@/assets/images/option-types-bg-1.jpg">
                    <div class="i-option-type-block--item--heading">
                      {{$t('option-types.normal.title')}}
                    </div>
                    <div class="i-option-type-block--body-text">
                      <p v-for="line in $t('option-types.normal.description').split('\n')" :key="line"> {{line}} </p>

                      <p> <small v-html="$t('option-types.more-info.description')"></small></p>
                      <router-link to="#" v-html="$t('option-types.more-info.try-the-quick-demo')"
                        class="btn btn-extruded btn-lg-pad i-option-type-block--cta">
                      </router-link>
                      <p v-html="$t('option-types.more-info.sign-up')"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>

    <div class="p-modal p-modal__option-types-block" id="option-spread-modal" data-toggle-group="option-types">
      <div class="p-modal--mobile-title option-types-block--item--heading">
        {{$t('option-types.spread.title')}}
        <div class="p-modal--mobile-close toggler" data-toggle-target="#option-spread-modal" data-toggle-class="open">
        </div>
      </div>
      <div class="p-modal--body-wrapper">
        <span class="p-modal--mobile-body-wrapper">
          <div class="p-modal--body">
            <div class="p-modal--content-wrapper">
              <div class="p-modal--content centered">
                <div class="container">
                  <div class="p-modal--content--inner option-types-block--item">
                    <div class="p-modal--bg toggler" data-toggle-target="#option-spread-modal" data-toggle-class="open">
                    </div>
                    <img data-src="@/assets/images/option-types-bg-2.jpg" class="i-option-type-block--item--background"
                      src="@/assets/images/option-types-bg-2.jpg">
                    <div class="i-option-type-block--item--heading">
                      {{$t('option-types.spread.title')}}
                    </div>
                    <div class="i-option-type-block--body-text">
                      <p v-for="line in $t('option-types.spread.description').split('\n')" :key="line"> {{line}} </p>

                      <p> <small v-html="$t('option-types.more-info.description')"></small></p>
                      <router-link to="#" v-html="$t('option-types.more-info.try-the-quick-demo')"
                        class="btn btn-extruded btn-lg-pad i-option-type-block--cta">
                      </router-link>
                      <p v-html="$t('option-types.more-info.sign-up')"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>

    <div class="p-modal p-modal__option-types-block" id="option-turbo-modal" data-toggle-group="option-types">
      <div class="p-modal--mobile-title option-types-block--item--heading">
        {{$t('option-types.turbo.title')}}
        <div class="p-modal--mobile-close toggler" data-toggle-target="#option-turbo-modal" data-toggle-class="open">
        </div>
      </div>
      <div class="p-modal--body-wrapper">
        <span class="p-modal--mobile-body-wrapper">
          <div class="p-modal--body">
            <div class="p-modal--content-wrapper">
              <div class="p-modal--content centered">
                <div class="container">
                  <div class="p-modal--content--inner option-types-block--item">
                    <div class="p-modal--bg toggler" data-toggle-target="#option-turbo-modal" data-toggle-class="open">
                    </div>
                    <img data-src="@/assets/images/option-types-bg-3.jpg" class="i-option-type-block--item--background"
                      src="@/assets/images/option-types-bg-3.jpg">

                    <div class="i-option-type-block--item--heading">
                      {{$t('option-types.turbo.title')}}
                    </div>
                    <div class="i-option-type-block--body-text">
                      <p v-for="line in $t('option-types.turbo.description').split('\n')" :key="line"> {{line}} </p>

                      <p> <small v-html="$t('option-types.more-info.description')"></small></p>
                      <router-link to="#" v-html="$t('option-types.more-info.try-the-quick-demo')"
                        class="btn btn-extruded btn-lg-pad i-option-type-block--cta">
                      </router-link>
                      <p v-html="$t('option-types.more-info.sign-up')"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>

    <div class="p-modal p-modal__option-types-block" id="option-turbo-spread-modal" data-toggle-group="option-types">
      <div class="p-modal--mobile-title option-types-block--item--heading">
        {{$t('option-types.turbo-spread.title')}}
        <div class="p-modal--mobile-close toggler" data-toggle-target="#option-turbo-spread-modal"
          data-toggle-class="open">
        </div>
      </div>
      <div class="p-modal--body-wrapper">
        <span class="p-modal--mobile-body-wrapper">
          <div class="p-modal--body">
            <div class="p-modal--content-wrapper">
              <div class="p-modal--content centered">
                <div class="container">
                  <div class="p-modal--content--inner option-types-block--item">
                    <div class="p-modal--bg toggler" data-toggle-target="#option-turbo-spread-modal"
                      data-toggle-class="open">
                    </div>
                    <img data-src="@/assets/images/option-types-bg-4.jpg" class="i-option-type-block--item--background"
                      src="@/assets/images/option-types-bg-4.jpg">
                    <div class="i-option-type-block--item--heading">
                      {{$t('option-types.turbo-spread.title')}}
                    </div>
                    <div class="i-option-type-block--body-text">
                      <p v-for="line in $t('option-types.turbo-spread.description').split('\n')" :key="line"> {{line}} </p>

                      <p> <small v-html="$t('option-types.more-info.description')"></small></p>
                      <router-link to="#" v-html="$t('option-types.more-info.try-the-quick-demo')"
                        class="btn btn-extruded btn-lg-pad i-option-type-block--cta">
                      </router-link>
                      <p v-html="$t('option-types.more-info.sign-up')"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>


    <div class="for-beginners-and-experts">
      <div class="grid-bg">
        <div class="container">
          <div class="section-heading">
            {{$t('home.demo.title')}}
          </div>
        </div>
      </div>
      <ForBeginnersAndExperts />
    </div>

    <div class="static-promo-articles">
      <div class="container">
        <div class="row">
          <span class="static-promo-articles-wrapper">
            <router-link to="/overview" class="col-sm-4 static-promo-articles-item">
              <div class="static-promo-articles-item-inner-wrapper">
                <div class="static-promo-articles-item-illustration">
                  <div class="illustration-wrapper">
                    <img data-src="@/assets/images/option-types.png" src="@/assets/images/option-types.png">
                  </div>
                </div>
                <div class="static-promo-articles-item-title">
                  {{$t('overview.title')}}
                </div>
                <div class="divider">
                </div>
                <div class="static-promo-articles-item-excerpt ">
                  {{$t('overview.description')}}
                </div>
              </div>
            </router-link>
            <router-link to="/why-trade" class="col-sm-4 static-promo-articles-item">
              <div class="static-promo-articles-item-inner-wrapper">
                <div class="static-promo-articles-item-illustration">
                  <div class="illustration-wrapper">
                    <img data-src="@/assets/images/why-binaries.png" src="@/assets/images/why-binaries.png">
                  </div>
                </div>
                <div class="static-promo-articles-item-title">
                  {{$t('why-trade.title')}}
                </div>
                <div class="divider">
                </div>
                <div class="static-promo-articles-item-excerpt">
                  {{$t('why-trade.description')}}
                </div>
              </div>
            </router-link>
            <!--
            <router-link to="/resources/videos" class="col-sm-4 static-promo-articles-item">
              <div class="static-promo-articles-item-inner-wrapper">
                <div class="static-promo-articles-item-illustration">
                  <div class="illustration-wrapper">
                    <img data-src="@/assets/images/trade-video.png" src="@/assets/images/trade-video.png">
                  </div>
                </div>
                <div class="static-promo-articles-item-title">
                  {{$t('videos.title')}}
                </div>
                <div class="divider">
                </div>
                <div class="static-promo-articles-item-excerpt">
                  {{$t('videos.description')}}
                </div>
              </div>
            </router-link>-->
          </span>
        </div>
      </div>
    </div>

   <!-- <on-the-go/>-->

    <div class="reasons ">
      <div class="container">
        <h2 class="section-heading">
          {{$t('home.reasons.title')}}
        </h2>
        <div class="row">
          <div class="col-lg-4 col-sm-6 reason-wrapper">
            <div class="reason shine-icon-container">
              <div class="content">
                <div class="icon shine-icon yen">
                  <div class="default">
                    <img src="@/assets/images/8-reasons-$.png">
                  </div>
                  <div class="hover">
                    <div class="shine">
                    </div>
                    <img src="@/assets/images/8-reasons-$.png">
                  </div>
                </div>
                <h3 class="heading">
                  {{$t('home.reasons.quick-fund')}}
                </h3>
                <p>
                  {{$t('home.reasons.quick-fund-description')}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 reason-wrapper">
            <div class="reason shine-icon-container">
              <div class="content">
                <div class="icon shine-icon  mobile">
                  <div class="default">
                    <img src="@/assets/images/8-reasons-$.png">
                  </div>
                  <div class="hover">
                    <div class="shine">
                    </div>
                    <img src="@/assets/images/8-reasons-$.png">
                  </div>
                </div>
                <h3 class="heading">
                  {{$t('home.reasons.mobile')}}
                </h3>
                <p>
                  {{$t('home.reasons.mobile-description')}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 reason-wrapper">
            <div class="reason shine-icon-container">
              <div class="content">
                <div class="icon shine-icon  two-fold">
                  <div class="default">
                    <img src="@/assets/images/8-reasons-$.png">
                  </div>
                  <div class="hover">
                    <div class="shine">
                    </div>
                    <img src="@/assets/images/8-reasons-$.png">
                  </div>
                </div>
                <h3 class="heading">
                  {{$t('home.reasons.payout')}}
                </h3>
                <p>
                  {{$t('home.reasons.payout-description')}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 reason-wrapper">
            <div class="reason shine-icon-container">
              <div class="content">
                <div class="icon shine-icon  support">
                  <div class="default">
                    <img src="@/assets/images/8-reasons-$.png">
                  </div>
                  <div class="hover">
                    <div class="shine">
                    </div>
                    <img src="@/assets/images/8-reasons-$.png">
                  </div>
                </div>
                <h3 class="heading">
                  {{$t('home.reasons.support')}}
                </h3>
                <p>
                  {{$t('home.reasons.support-description')}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 reason-wrapper">
            <div class="reason shine-icon-container">
              <div class="content">
                <div class="icon shine-icon  five-k cashback-idr">
                  <div class="default">
                    <img src="@/assets/images/8-reasons-$.png">
                  </div>
                  <div class="hover">
                    <div class="shine">
                    </div>
                    <img src="@/assets/images/8-reasons-$.png">
                  </div>
                </div>
                <h3 class="heading">
                  {{$t('home.reasons.cashback')}}
                </h3>
                <p>
                  {{$t('home.reasons.cashback-description')}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 reason-wrapper">
            <div class="reason shine-icon-container">
              <div class="content">
                <div class="icon shine-icon  expert">
                  <div class="default">
                    <img src="@/assets/images/8-reasons-$.png">
                  </div>
                  <div class="hover">
                    <div class="shine">
                    </div>
                    <img src="@/assets/images/8-reasons-$.png">
                  </div>
                </div>
                <h3 class="heading">
                  {{$t('home.reasons.specialist')}}
                </h3>
                <p>
                  {{$t('home.reasons.specialist-description')}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </fragment>
</template>

<script>
  import '../../assets/css/home.css'
  import '../../assets/css/home-news.css'
  import HomeBanner from '../../layout/HomeBanner.vue'
  import HomeNews from '../../layout/HomeNews.vue'
  import ForBeginnersAndExperts from './Home/ForBeginnersAndExperts.vue'
  import OnTheGo from './Home/OnTheGo.vue'

  export default {
    data() {
      return {
      }
    },
    components: {
      HomeBanner,
      HomeNews,
      ForBeginnersAndExperts,
      // OnTheGo
      },
  }
</script>